var React = require('react');

function CheckmarkMicro (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#737373","strokeWidth":"1.8","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("path",{"d":"M7.692.318L3.07 6.371M.308 2.864L3.084 6.37"})));
}

CheckmarkMicro.defaultProps = {"width":"8","height":"7","viewBox":"0 0 8 7"};

module.exports = CheckmarkMicro;

CheckmarkMicro.default = CheckmarkMicro;
